import Evidence from 'redpoints-model-js/model/testpurchase/evidence/Evidence';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_FETCH_LINK_INFO,
  TEST_PURCHASE_SET_EVIDENCES_URL,
} from '../../../actions/actionTypes';

export const linkInfoAdditionalReducer = (state, action) => {
  switch (action.type) {
    case TEST_PURCHASE_SET_EVIDENCES_URL: {
      const { evidencesUrl } = action.payload;

      if (state.data) {
        state.data.evidence = Object.assign(
          new Evidence(),
          state.data.evidence ?? {},
          {
            linkId: state.data.link?.linkId ?? null,
            addressId: state.data.address?.addressId ?? null,
            customerId: state.data.address?.customerId ?? null,
            evidencesUrl,
          }
        );
      }

      return state;
    }
    default: {
      return state;
    }
  }
};

const linkInfo = fetchReducerGenerator(
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_FETCH_LINK_INFO,
  linkInfoAdditionalReducer
);

export default linkInfo;
